import {DataSource} from "../../../constants/DataSource/DataSource";
import React, {FC} from "react";
import DataSources from "components/DataSources/DataSources";
import {ExternalWarehouseService} from "../../DataSources/Items/ExternalWarehouseService";
import {LabelOnly} from "../../DataSources/Items/LabelOnly";

interface DataSourcesProps {
    data: DataSource[],
    updateDataHandler: (data: DataSource[]) => void,
    isSupportDataSourceChange: boolean
    isIntegrationWarehouse: boolean
    isSupplierSellerWarehouse: boolean
    isPublicWarehouse: boolean
    externalWhService: string
    externalWhID: string
    whID: string
}

const DataSourcesWrapper: FC<DataSourcesProps> = (
    {
        data,
        updateDataHandler,
        isSupportDataSourceChange,
        isIntegrationWarehouse,
        isSupplierSellerWarehouse,
        externalWhService,
        isPublicWarehouse,
        externalWhID,
        whID
    }
) => {
    return (
        <div className="mt-6">
            <div className={'text-[#1E293B] font-bold text-l w-full text-left'}>
                Источники данных
            </div>

            {isSupportDataSourceChange ?
                <>
                    <p className={'text-[#94A3B8] text-[14px]  mb-3 w-5/6'}>
                        Активным может быть только один источник
                    </p>

                    <div className="flex">
                        <svg className="w-4 h-4 flex-shrink-0 fill-current text-indigo-500 mt-[3px] mr-3" viewBox="0 0 16 16">
                            <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm1 12H7V7h2v5zM8 6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"></path>
                        </svg>
                        <div className={'text-[#94A3B8] text-[14px] w-5/6'}>
                            Внимание! Если в источнике отсутствует продукт, который ранее учитывался, то его остаток обнулится "0".
                        </div>
                    </div>

                    <DataSources data={data} updateDataHandler={updateDataHandler} whID={whID}></DataSources>
                </>
                :
                <>
                    {externalWhService && externalWhID &&
                        <ExternalWarehouseService externalWhService={externalWhService} externalWhID={externalWhID}></ExternalWarehouseService>
                    }

                    {isIntegrationWarehouse &&
                        <LabelOnly label="API LK.MARKET"></LabelOnly>
                    }

                    {isSupplierSellerWarehouse &&
                        <LabelOnly label={'LK' + externalWhID.replace('se_spl_', '')}></LabelOnly>
                    }

                    {isPublicWarehouse &&
                        <LabelOnly label={`Раздел "Отправка"`}></LabelOnly>
                    }
                </>
            }

        </div>
    )
}

export default DataSourcesWrapper
